import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class JobWorkServices {
  /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} departmentId
   * @param {*} status
   * @param {*} moStatus
   * @param {*} route
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @param {*} resourceId
   * @return
   */
  getJobWorks = async (orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen) => {
    let url = `${Constants.JOB_WORK}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (status) url += `status=${status}&`;
    if (moStatus) url += `mo_status=${moStatus}&`;
    if (page) url += `page=${page}&`;
    if (route) url += `route=${route}`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (assignee) url += `user_id=${assignee}&`;
    if (resourceId) url += `resource_id=${resourceId}&`;
    if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
    if (isListScreen) url += `list_screen=${isListScreen}&`;
    const jobWorks = await Helpers.get({ url });
    return jobWorks;
  };

  getJobWorksV2 = async (orgId, tenantId, departmentId, status, moStatus, route, page, limit, searchKeyword, startDate, endDate, assignee, resourceId, resourceGroupId, sellerId, isListScreen) => {
    let url = `${Constants.JOB_WORK_V2}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (status) url += `status=${status}&`;
    if (moStatus) url += `mo_status=${moStatus}&`;
    if (page) url += `page=${page}&`;
    if (route) url += `route=${route}`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (assignee) url += `assignee_user_id=${assignee}&`;
    if (resourceId) url += `resource_id=${resourceId}&`;
    if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
    if (sellerId) url += `subcontractor_seller_id=${sellerId}&`;
    if (isListScreen) url += `list_screen=${isListScreen}&`;
    const jobWorks = await Helpers.get({ url });
    return jobWorks;
  };

  /**
     *
     * @param tenantId
     * @param productionRoutesLineId
     * @returns {Promise<*>}
     */
  getJobWorkById = async (tenantId, productionRoutesLineId) => {
    let url = `${Constants.JOB_WORK}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (productionRoutesLineId) url += `prl_id=${productionRoutesLineId}&`;
    const jobWork = await Helpers.get({ url });
    return jobWork;
  };

  getJobWorkByIdV2 = async (tenantId, productionRoutesLineId) => {
    let url = `${Constants.JOB_WORK_V2}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (productionRoutesLineId) url += `prl_id=${productionRoutesLineId}&`;
    const jobWork = await Helpers.get({ url });
    return jobWork;
  };

  /**
   * @param {*} orgId
   * @param {*} tenantId
   * @param {*} moId
   * @return
   */
  getJobWorkByMoId = async (orgId, tenantId, moId, isListScreen) => {
    let url = `${Constants.JOB_WORK}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (moId) url += `mo_id=${moId}&`;
    if (isListScreen) url += `list_screen=${isListScreen}&`;

    const jobWorks = await Helpers.get({ url });

    return jobWorks;
  };

  getJobWorkByMoIdV2 = async (orgId, tenantId, moId, isListScreen) => {
    let url = `${Constants.JOB_WORK_V2}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (moId) url += `mo_id=${moId}&`;
    if (isListScreen) url += `list_screen=${isListScreen}&`;

    const jobWorks = await Helpers.get({ url });

    return jobWorks;
  };

  /**
     *
     * @param payload
     * @returns {Promise<*>}
     */
  updateJobWork = async (payload) => {
    const jobWorks = await Helpers.put({
      url: Constants.UPDATE_JOB_WORK,
      data: payload,
    });
    return jobWorks;
  };

  updateJobWorkV2 = async (payload) => {
    const jobWorks = await Helpers.put({
      url: Constants.UPDATE_JOB_WORK_V2,
      data: payload,
    });
    return jobWorks;
  };

  /**
     *
     * @param orgId
     * @returns {Promise<*>}
     */
  getJobOperators = async (orgId) => {
    const jobOperators = await Helpers.get({
      url: `${Constants.GET_JOB_OPERATORS}?org_id=${orgId}`,
    });
    return jobOperators;
  };

  /**
     *
     * @param groupBy
     * @param tenantIds
     * @param orgId
     * @param status
     * @param page
     * @param limit
     * @param userIds
     * @returns {Promise<*>}
     */
  getKanbanJobWorks = async (groupBy, tenantIds, orgId, status, page, limit, userIds, startDate, endDate, departmentId, searchKeyword, moStatus, resourceId, resourceGroupId) => {
    let subUrl = '';
    if (groupBy === 'machine') subUrl = 'jw_group_by_resource';
    if (groupBy === 'work_center') subUrl = 'jw_group_by_resource_group';
    if (groupBy === 'operator') subUrl = 'jw_group_by_assignee';
    let url = `${Constants.ROUTING_PROCESS}/${subUrl}?`;
    if (tenantIds) url += `tenant_id=${tenantIds}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (status) url += `status=${status}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (userIds) url += `user_id=${userIds}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (moStatus) url += `mo_status=${moStatus}&`;
    if (resourceId) url += `resource_id=${resourceId}&`;
    if (resourceGroupId) url += `resource_group_id=${resourceGroupId}&`;
    const jobWorks = await Helpers.get({
      url,
    });
    return jobWorks;
  };

  getMasterProductionProcessKanban = async (payload) => {
    let url = `${Constants.MASTER_PRODUCTION_PROCESS}/list?`;
    if (payload?.page) url += `page=${payload.page}&`;
    if (payload?.limit) url += `limit=${payload.limit}&`;
    if (payload?.color) url += `color=${encodeURIComponent(payload.color)}&`;
    if (payload?.searchKeyword || payload?.search_keyword) url += `search_keyword=${payload?.searchKeyword}&`;
    if (payload?.tenantIds || payload?.tenant_ids) url += `tenant_ids=${payload?.tenantIds || payload?.tenant_ids}&`;
    if (payload?.departmentIds || payload?.department_ids) url += `department_ids=${payload?.departmentIds || payload?.department_ids}&`;
    if (payload?.workCenterIds || payload?.work_center_ids) url += `work_center_ids=${payload?.workCenterIds || payload?.work_center_ids}&`;
    if (payload?.machineIds || payload?.machine_ids) url += `machine_ids=${payload?.machineIds || payload?.machine_ids}&`;
    if (payload?.status) url += `status=${payload.status}&`;
    if (payload?.customerIds || payload?.customer_ids) url += `customer_ids=${payload?.customerIds || payload?.customer_ids}&`;
    if ((payload?.scheduledStartTime || payload?.scheduled_start_time) && (payload?.scheduledEndTime || payload?.scheduled_end_time)) url += `scheduled_start_time=${payload?.scheduledStartTime || payload?.scheduled_start_time}&scheduled_end_time=${payload?.scheduledEndTime || payload?.scheduled_end_time}&`;
    if (payload?.advanceFilters || payload?.advance_filter) url += `advance_filter=${payload?.advanceFilters || payload?.advance_filter}&`;
    if (payload?.productSkuIds || payload?.product_sku_ids) url += `product_sku_ids=${payload?.productSkuIds || payload?.product_sku_ids}&`;
    if (payload?.isScheduled || payload?.is_scheduled) url += `is_scheduled=${payload?.isScheduled || payload?.is_scheduled}&`;
    if (payload?.groupBy || payload?.group_by) url += `group_by=${payload?.groupBy || payload?.group_by}&`;
    if ((payload?.groupId || payload?.group_id) && (payload?.groupBy || payload?.group_by)) {
      let subPrefix = '';
      if ((payload?.groupBy || payload?.group_by) === 'work_center') subPrefix = 'work_center_ids';
      if ((payload?.groupBy || payload?.group_by) === 'machine') subPrefix = 'machine_ids';
      if ((payload?.groupBy || payload?.group_by) === 'finished_good') subPrefix = 'product_sku_ids';
      url += `${subPrefix}=${payload?.groupId || payload?.group_id}&`;
    }
    if (payload?.groupName === 'column-Unassigned' || payload?.group_name === 'column-Unassigned') url += 'group_name=unassigned&';
    const jobWorks = await Helpers.get({
      url,
    });
    return jobWorks;
  };

  getSubJobCardsKanban = async (payload) => {
    let url = `${Constants.GET_SUB_JOB_CARD_LIST}?`;
    if (payload?.page) url += `page=${payload.page}&`;
    if (payload?.limit) url += `limit=${payload.limit}&`;
    if (payload?.status) url += `status=${payload.status}&`;
    if (payload?.searchKeyword || payload?.search_keyword) url += `search_keyword=${payload?.searchKeyword || payload?.search_keyword}&`;
    if (payload?.startDateTime || payload?.start_date_time) url += `start_date_time=${payload?.startDateTime || payload?.start_date_time}&`;
    if (payload?.endDateTime || payload?.end_date_time) url += `end_date_time=${payload?.endDateTime || payload?.end_date_time}&`;
    if (payload?.shiftId || payload?.shift_id) url += `shift_id=${payload?.shiftId || payload?.shift_id}&`;
    if (payload?.tenantDepartmentId || payload?.tenant_department_id) url += `tenant_department_id=${payload?.tenantDepartmentId || payload?.tenant_department_id}&`;
    if (payload?.tenantId || payload?.tenant_id) url += `tenant_id=${payload?.tenantId || payload?.tenant_id}&`;
    if (payload?.workCenterIds || payload?.resource_group_id) url += `resource_group_id=${payload?.workCenterIds || payload?.resource_group_id}&`;
    if (payload?.machineIds || payload?.resource_id) url += `resource_id=${payload?.machineIds || payload?.resource_id}&`;
    if (payload?.productSkuIds || payload?.product_sku_id) url += `product_sku_id=${payload?.productSkuIds || payload?.product_sku_id}&`;
    if (payload?.operatorId || payload?.operator_id) url += `operator_id=${payload?.operatorId || payload?.operator_id}&`;
    if (payload?.batchIds) url += `batch_ids=${payload.batchIds}&`;
    if (payload?.groupBy || payload?.group_by) url += `group_by=${payload?.groupBy || payload?.group_by}&`;
    if ((payload?.groupId || payload?.group_id) && (payload?.groupBy || payload?.group_by)) {
      let subPrefix = '';
      if ((payload?.groupBy || payload?.group_by) === 'work_center') subPrefix = 'resource_group_id';
      if ((payload?.groupBy || payload?.group_by) === 'machine') subPrefix = 'resource_id';
      if ((payload?.groupBy || payload?.group_by) === 'finished_good') subPrefix = 'product_sku_id';
      url += `${subPrefix}=${payload?.groupId || payload?.group_id}&`;
    }
    if (payload?.groupName === 'column-Unassigned' || payload?.group_name === 'column-Unassigned') url += 'group_name=unassigned&';
    const subJobCards = await Helpers.get({
      url,
    });
    return subJobCards;
  }

  processJwMaterial = async (payload) => {
    const jobWorks = await Helpers.post({
      url: Constants.PROCESS_JW_MATERIAL,
      data: payload,
    });
    return jobWorks;
  };

  processJwMaterialComplete = async (payload) => {
    const jobWorks = await Helpers.put({
      url: Constants.PROCESS_JW_MATERIAL,
      data: payload,
    });
    return jobWorks;
  };

  getMasterProductionProcessList = async (payload) => {
    let url = `${Constants.MASTER_PRODUCTION_PROCESS}/list?`;
    if (payload?.page) url += `page=${payload.page}&`;
    if (payload?.limit) url += `limit=${payload.limit}&`;
    if (payload?.searchKeyword) url += `search_keyword=${payload.searchKeyword}&`;
    if (payload?.tenantIds) url += `tenant_ids=${payload.tenantIds}&`;
    if (payload?.departmentIds) url += `department_ids=${payload.departmentIds}&`;
    if (payload?.workCenterIds) url += `work_center_ids=${payload.workCenterIds}&`;
    if (payload?.machineIds) url += `machine_ids=${payload.machineIds}&`;
    if (payload?.status) url += `status=${payload.status}&`;
    if (payload?.customerIds) url += `customer_ids=${payload.customerIds}&`;
    if (payload?.scheduledStartTime && payload?.scheduledEndTime) url += `scheduled_start_time=${payload.scheduledStartTime}&scheduled_end_time=${payload.scheduledEndTime}&`;
    if (payload?.advanceFilters) url += `advance_filter=${payload.advanceFilters}&`;
    if (payload?.productSkuIds) url += `product_sku_ids=${payload.productSkuIds}&`;
    if (payload?.isScheduled) url += `is_scheduled=${payload.isScheduled}&`;
    const masterProductionProcessList = await Helpers.get({
      url,
    });
    return masterProductionProcessList;
  };

  getSubJobCardsList = async (payload) => {
    let url = `${Constants.GET_SUB_JOB_CARD_LIST}?`;
    if (payload?.page) url += `page=${payload.page}&`;
    if (payload?.limit) url += `limit=${payload.limit}&`;
    if (payload?.status) url += `status=${payload.status}&`;
    if (payload?.searchKeyword) url += `search_keyword=${payload.searchKeyword}&`;
    if (payload?.startDateTime) url += `start_date_time=${payload.startDateTime}&`;
    if (payload?.endDateTime) url += `end_date_time=${payload.endDateTime}&`;
    if (payload?.shiftId) url += `shift_id=${payload.shiftId}&`;
    if (payload?.tenantDepartmentId) url += `tenant_department_id=${payload.tenantDepartmentId}&`;
    if (payload?.tenantId) url += `tenant_id=${payload.tenantId}&`;
    if (payload?.workCenterIds) url += `resource_group_id=${payload.workCenterIds}&`;
    if (payload?.machineIds) url += `resource_id=${payload.machineIds}&`;
    if (payload?.productSkuIds) url += `product_sku_id=${payload.productSkuIds}&`;
    if (payload?.operatorId) url += `operator_id=${payload.operatorId}&`;
    if (payload?.batchIds) url += `batch_ids=${payload.batchIds}&`;
    if (payload?.color) url += `color=${encodeURIComponent(payload.color)}&`;
    const subJobCards = await Helpers.get({
      url,
    });
    return subJobCards;
  };
}
export default new JobWorkServices();
